/*
 *	services v1.0.0 
 *	(c) 2019 Henk Salomons
 *	
 *	responsible for fetching data from and to the amazilia backoffice.
 */

import Vue from 'vue';

/** 
 *  Eventbus, used to emit an recieve events between components 
 */
const EventBus = new Vue();

var services = function () {
  //if (shoppingCartService) {
  //  console.log("services says: " + shoppingCartService._shoppingCartLoading);
  //}


  var _products = null;
  var _productExtras = null;
  var _allergies = null;
  var _categoryId = null;
  var _categoryBusy = false;
  var _allergiesLoaded = false;
  var _allergiesLoading = false;
  var _selectedAllergyIds = null;
  var _shippingmethods = null;
  var _shippingMethodsLoading = false;
  var _allergieCompleteQue = [];
  var _serviceTimer = null;

  //var _detailProduct = { "name" : "name" };
  var _detailProduct = {
    name: '',
    loaded: false
  };

  var _banner = {
    mediaUrl: "",
    tekstOranje: "",
    tekstWit: "",
    tekstOranje2: ""
  };

  /*
           Loads the async view from the server
       */
  var _getAsyncView = function (viewName, data, enableCache, callback) {
    data.viewName = viewName;
    var time = Date.now();
    var headers = {};

    if (enableCache) {
      headers.PwaEnableCache = 1;
    } else {
      headers.PwaDisableCache = 1;
    }
    headers.CultureCode = window.pwa_currentCultureName;

    $.ajax('/umbraco/vwa/async/GetAsyncView/', { type: 'POST', headers: headers, data: data, complete: complete, error: error });

    function complete(response, status, xhr) {
      if (status === "error") {
        var msg = "[GetAsyncView] error loading view: ";
        console.log(msg + response.responseText);
        return;
      }
      var time2 = Date.now();

      //	console.log('query took: ' + Math.abs(time - time2) + ' milisecons');
      callback && callback(response.responseText);
    }

    function error(response, status) {
      var msg = "[GetAsyncView] error loading view: ";
      console.log(msg + response.responseText);

      callback && callback(response.responseText);
      return;
    }
  }

  return {

    ///*
    //    Loads the async view from the server
    //*/
    //GetAsyncView: function (viewName, data, enableCache, callback) {
    //  data.viewName = viewName;
    //  var time = Date.now();
    //  var headers = {};

    //  if (enableCache) {
    //    headers.PwaEnableCache = 1;
    //  } else {
    //    headers.PwaDisableCache = 1;
    //  }

    //  $.ajax('/umbraco/vwa/async/GetAsyncView/', { headers: headers, data: data, complete: complete, error: error });

    //  function complete(response, status, xhr) {
    //    if (status === "error") {
    //      var msg = "[GetAsyncView] error loading view: ";
    //      console.log(msg + response.responseText);
    //      return;
    //    }
    //    var time2 = Date.now();

    //    console.log('query took: ' + Math.abs(time - time2) + ' milisecons');
    //    callback && callback(response.responseText);
    //  }

    //  function error(response, status) {
    //    var msg = "[GetAsyncView] error loading view: ";
    //    console.log(msg + response.responseText);

    //    callback && callback(response.responseText);
    //    return;
    //  }
    //},

    //UpdateWithAction: function (selector, enableCache, callback) {
    //  var el = $(selector);
    //  this.GetAsyncAction(el, null, enableCache, function (result) {
    //    el.html(result);
    //    callback && callback();
    //  });
    //},

    //GetAsyncAction: function (el, data, enableCache, callback) {

    //  var action = el.data('asyncaction');
    //  if (!action) {
    //    console.log('[services] element does not contain any asyncaction data');
    //    return "[noaction]";
    //  }
    //  var time = Date.now();

    //  var headers = {};
    //  if (enableCache) {
    //    headers.PwaEnableCache = 1;
    //  } else {
    //    headers.PwaDisableCache = 1;
    //  }

    //  $.ajax(action, { headers: headers, data: data, complete: complete, error: error });

    //  function complete(response, status, xhr) {
    //    if (status === "error") {
    //      var msg = "[GetAsyncView] error loading view: ";
    //      console.log(msg + response.responseText);
    //      return;
    //    }
    //    var time2 = Date.now();

    //    console.log('query took: ' + Math.abs(time - time2) + ' milisecons');
    //    callback && callback(response.responseText);
    //  }

    //  function error(response, status) {
    //    var msg = "[GetAsyncView] error loading view: ";
    //    console.log(msg + response.responseText);

    //    callback && callback(response.responseText);
    //    return;
    //  }
    //},

    /**
     * Gets the products of the requested category from cache or api
     * @param {number} categoryId - the categoryid
     * @param {function} complete - the complete callback
     * @param {function} error - the error callback
     */
    getProducts: function (categoryId, complete, error) {

      if (!_categoryBusy && _categoryId === categoryId) {
        complete(_products);
        return;
      }

      // check for pending requests
      if (_categoryBusy) {
        // cancel any pending request
        if (_serviceTimer) {
          window.clearTimeout(_serviceTimer);
        }

        // start new timeout
        _serviceTimer = window.setTimeout(function () {
          services.getProducts(categoryId, complete, error);
        }, 100);
      } else {

        var headers = {};
        var enableCache = true;

        if (enableCache) {
          headers.PwaEnableCache = 1;
        } else {
          headers.PwaDisableCache = 1;
        }
        headers.CultureCode = window.pwa_currentCultureName;

        _categoryBusy = true;
        $.ajax('/umbraco/vwa/JsonList/GetList/', { headers: headers, data: { "categoryId": categoryId }, complete: _complete, error: error });
      }


      function _complete(data) {
        _products = data.responseJSON.products;
        _productExtras = data.responseJSON.prepMethods;
        _categoryId = categoryId;
        _categoryBusy = false;
        complete(_products);
      }
    },

    getGridHtml: function (categoryId, complete, error) {

      // call naar Asynccontroller controller dmv $.ajax(''')
      _getAsyncView("RenderGridHtml", { viewName: "RenderGridHtml", hash: "#?categoryid=" + categoryId }, false, complete);

      /*
     var res = $.ajax('/umbraco/vwa/Async/GetAsyncView/', { viewName: "RenderGridHtml", hash: "#?categoryid=" + categoryId) }).done(function (result) {
          if (typeof complete == 'function') {
            complete( result.data);
          }
      });
*/

      /*
            if (typeof complete == 'function') {
              var resultHtml = "";
      
              var res = $.ajax({
                type: "POST",
                url: "/umbraco/vwa/Async/GetGridFromCategory?categoryId="+categoryId,
              }).done(function (jqXHROrData, textStatus, jqXHROrErrorThrown) {
                resultHtml = res.resultHtml;
              });
              complete(resultHtml);
            }
      */
    },

    loadProduct: function (productId) {
      var _this = this;
      _detailProduct.loaded = false;

      var headers = {};
      headers.PwaEnableCache = 1;
      headers.CultureCode = window.pwa_currentCultureName;

      var res = $.ajax({
        type: "POST",
        headers: headers,
        url: "/umbraco/vwa/JsonList/GetProductById/?id=" + productId + "&culturecode=" +  window.pwa_currentCultureName
      })
        .done(function (jqXHROrData, textStatus, jqXHROrErrorThrown) {

          for (var a in res.responseJSON.product) {
            _detailProduct[a] = res.responseJSON.product[a];
          }

          // merge the preperation methods with the one we already have
          for (var key in res.responseJSON.prepMethods) {
            _productExtras[key] = res.responseJSON.prepMethods[key]
          }

          _detailProduct.loaded = true;
        });
    },

    detailProduct: _detailProduct,

    /**
     * Gets the preperation methods
     * @param {any} id - the id of the preperation method
     * @returns {object} - The requested preperation method
     */
    getProductExtra: function (id) {
      return _productExtras[id];
    },

    /**
     * Gets the allergies from api
     * @param {function} complete - The complete callback
     * @param {function} error - the error callback
     */
    getAllergies: function (complete, error) {
      var vm = this;

      if (_allergies) {
        complete(_allergies);
        return;
      }

      var headers = {};
      headers.PwaEnableCache = 1;
      headers.CultureCode = window.pwa_currentCultureName;
   
      if (typeof (complete) === 'function')
        _allergieCompleteQue.push(complete);

      if (_allergiesLoading) {
        // already loading from another vue component
        // add complete function to que

      }
      else {
        _allergiesLoading = true;
        $.ajax('/umbraco/vwa/JsonList/GetAllergies', { headers: headers, complete: _complete, error: error });
      }

      function _complete(data) {

        _allergies = data.responseJSON.allergies;

        vm.AllergiesLoaded = true;
        _allergiesLoaded = true;

        // merge active state with local storage
        var selectedIds = vm.getSelectedAllergies();

        for (var allergie in _allergies) {
          _allergies[allergie].active = false;

          if (selectedIds) {
            for (var i in selectedIds) {
              if (selectedIds[i] === _allergies[allergie].Id) {
                _allergies[allergie].active = true;
              }
            }
          }
        }

        // complete funtions
        while (_allergieCompleteQue.length) {
          _allergieCompleteQue.pop()(_allergies);
        };


      }

    },

    /** 
     * Gets the selected allergies from localstorrage as an array if id's
     * @returns {array} - the selected allergies 
     */
    getSelectedAllergies: function () {
      if (_selectedAllergyIds === null) {
        if (window.localStorage && window.localStorage.getItem('selectedAllergies') !== null) {
          _selectedAllergyIds = JSON.parse(window.localStorage.getItem('selectedAllergies'));
        } else {
          _selectedAllergyIds = [];
        }
      }
      return _selectedAllergyIds;
    },

    /** 
     *  Stores the selected allergie id's to local storrage
     * @param {array} ids - An array of selected allergy id's
     **/
    setSelectedAllergies: function (ids) {
      _selectedAllergyIds = ids;
      window.localStorage.setItem('selectedAllergies', JSON.stringify(ids));
    },

    /**
     * Gets the allergy by Id
     * @param {array} id - The id of the allergie
     * @returns {object} - the requested allergy
     **/
    getAllergy: function (id) {
      return _allergies[id];
    },

    /**
    * Are the allergies loaded
    */
    AllergiesLoaded: _allergiesLoaded,

    /**
     * Gets the price of an Amazilia Product, based on the quantity
     * @param {any} product - the product
     * @param {any} quantity - the requested quantity
     * @returns {decimal} the price as a decimal
     */
    getPrice: function (product, quantity) {
      // todo, tierprices
      return product.price.priceInclTax * quantity;
    },

    /**
    * returns the default dish price, the default preparation methods are added
    * @param {any} product - the product
    * @param {any} quantity - the requested quantity
    * @returns {decimal} the price as a decimal
    */
    getDefaultDishPrice: function (product, quantity) {

      if (product.defaultDishPrice) {
        return product.defaultDishPrice.priceInclTax * quantity;
      }

      return this.getPrice(product, quantity);
    },

    /**
     * Returns the product filtered by allergie
     * @returns {object} the filtered products as an dictionary
     **/
    filterProducts: function () {

      var newProducts = {};
      var count = 0;

      var filterAllergies = this.getSelectedAllergies();

      if (!filterAllergies.length) {
        return _products;
      }

      for (let key in _products) {
        let valid = true;

        let product = _products[key];

        if (product.content.allergenen) {
          for (let key1 in filterAllergies) {
            if (product.content.allergenen.includes(filterAllergies[key1])) {
              valid = false;
              break;
            }
          }
        }

        if (valid)
          newProducts[key] = _products[key];

      }

      return newProducts;

    },

    shippingMethods: {
      shippingmethods: [] // the available shipping methods
      , warnings: [] // the warnings, if any,
      , loaded: false
    },

    /**
     * Gets the shipping methods
     * @param {any} url - the url of the api
     * @param {any} complete - Complete callback function
     * @param {any} error - Error callback function
     */
    loadShippingMethods: function (url, complete, error) {
      var vm = this;

      if (!url) {
        console.log('loadShippingMethods url not set');
        return;
      }

      //if (!vm.shoppingCart.model.items.length) {
      //	complete(shippingMethods);
      //}

      // asume that the shippingmethods don't depend on cart content, otherwise, remove this check
      if (vm.shippingMethods.loaded) {
        complete && complete(vm.shippingMethods);
        return;
      }

      if (_shippingMethodsLoading) {
        // previous call is not finished yet.
        setTimeout(function () { vm.loadShippingMethods(url, complete, error); }, 100);
      } else {
        _shippingMethodsLoading = true;
        var headers = {};
        headers.PwaDisableCache = 1;
        headers.CultureCode = window.pwa_currentCultureName;
        $.ajax(url, { headers: headers, complete: _complete, error: _error });
      }

      function _complete(result) {
        _shippingMethodsLoading = false;
        if (result.status == 200 && result.responseJSON && result.responseJSON.success) {
          for (var v in result.responseJSON.data) {
            vm.shippingMethods[v] = result.responseJSON.data[v];
          }
          vm.shippingMethods.loaded = true;
          complete && complete(vm.shippingMethods);
        } else {
          _error(result);
        }
      }

      function _error(err) {
        _shippingMethodsLoading = false;
        if (error) {
          error(err);
        } else {
          console.log('Error retrieving shippingmethods' + err);
        }
      }
    },


    /**
    * loads the banner for the requested category
    * @param {any} catId - the requested category
    * @param {any} complete - Complete callback function
    * @param {any} error - Error callback function
    */
    setHeaderBanner: function (catId) {
      var res = $.ajax("/umbraco/vwa/Async/getHeaderBanner", {
        type: 'POST',
        data: {
          catId: catId
        }
      })
        .done(function (jqXHROrData, textStatus, jqXHROrErrorThrown) {
          for (var key in res.responseJSON) {
            _banner[key] = res.responseJSON[key];
          }
          EventBus.$emit('reload-header-banner', null);
        });
    },
    Banner: _banner
  };

}();
window.services = services;


export { services, EventBus };



// WEBPACK FOOTER //
// ./Vue/Src/Services/Services.js